var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPinCodesBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.612 10.029V5.197c0-.902-.683-1.926-1.53-2.267L11.952.421a5.709 5.709 0 0 0-4.303 0l-6.13 2.51C.682 3.27 0 4.294 0 5.196v4.832C0 15.41 3.907 20.45 9.245 21.926c.363.099.759.099 1.122 0 5.338-1.475 9.245-6.515 9.245-11.897Zm-8.98 1.926v2.894a.831.831 0 0 1-.826.826.831.831 0 0 1-.826-.826v-2.894a2.748 2.748 0 0 1-1.925-2.609 2.751 2.751 0 1 1 5.502 0 2.738 2.738 0 0 1-1.926 2.609Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinCodesBlack);
export default __webpack_public_path__ + "static/media/ic_pin_codes_black.defad68cb63bd362ca800c0182edaee4.svg";
export { ForwardRef as ReactComponent };